import * as React from "react";

import { useLocalization } from "@shared-ui/localization-context";
import { PropertyFilteredReviews } from "@shared-ui/lodging-reviews";

import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";

import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkToolbar, UitkToolbarProps } from "uitk-react-toolbar";

const WrappedPropertyFilteredReviews = PropertyBexApiWrapper(PropertyFilteredReviews);

export const PropertyFilteredReviewsDialog: React.FC<ComponentProps & { onClose: () => void }> = ({
  context,
  onClose,
}) => {
  const { formatText } = useLocalization();
  const triggerRef = React.createRef<HTMLElement>();

  const toolbarProps: UitkToolbarProps = {
    toolbarTitle: formatText("reviews.dialog.title"),
    navigationContent: {
      navIconLabel: formatText("reviews.dialog.close.a11yLabel"),
      onClick: onClose,
    },
  };

  return (
    <UitkSheet type="full" isVisible triggerRef={triggerRef}>
      <UitkToolbar {...toolbarProps} />
      <UitkSheetContent fullSheetContentMaxWidth="extra-large">
        <WrappedPropertyFilteredReviews context={context} />
      </UitkSheetContent>
    </UitkSheet>
  );
};
